import { EConfiguratorQuestionType, IConfiguratorSection } from '../models/configurator.model';
import {
  configuratorIcon,
  MATERIAL_LINE_OPTIONS,
  MATERIAL_SELECTION_OPTIONS
} from './configurator-options.data';

import { INSPIRATION_FILES_QUESTION } from './photos-step.config';

const T = 'ProjectConfiguratorV2.Questions';
const S = 'ProjectConfiguratorV2.Sections';

/**
 * Step 4 "Ausstattung". Nothing is required. Still missing: the Stil-Finder (needs its pictures, D4) and the
 * inspiration upload (with the photo groups of step 5, D5).
 */
export const EQUIPMENT_STEP_SECTIONS: IConfiguratorSection[] = [
  {
    id: 'equipment',
    questions: [
      {
        id: 'materials',
        type: EConfiguratorQuestionType.TILES,
        summaryLabel: `${T}.materials.summary`,
        label: `${T}.materials.label`,
        options: MATERIAL_LINE_OPTIONS,
        columns: 3
      },
      {
        id: 'materialSelection',
        type: EConfiguratorQuestionType.CHIPS,
        summaryLabel: `${T}.materialSelection.summary`,
        label: `${T}.materialSelection.label`,
        options: MATERIAL_SELECTION_OPTIONS,
        allowCustom: true
      }
    ]
  },
  {
    id: 'inspiration',
    icon: configuratorIcon('sparkle'),
    title: `${S}.inspiration`,
    questions: [
      INSPIRATION_FILES_QUESTION,
      {
        id: 'inspirationLinks',
        type: EConfiguratorQuestionType.LINKS,
        summaryLabel: `${T}.inspirationLinks.summary`,
        label: `${T}.inspirationLinks.label`,
        placeholder: `${T}.inspirationLinks.placeholder`,
        customLabel: `${T}.inspirationLinks.add`
      },
      {
        id: 'importantNote',
        type: EConfiguratorQuestionType.TEXTAREA,
        summaryLabel: `${T}.importantNote.summary`,
        label: `${T}.importantNote.label`,
        placeholder: `${T}.importantNote.placeholder`
      }
    ]
  }
];
